import React, { Component } from 'react';
import { NICE_CHAT_URL, NICE_CHAT_PORT, NICE_CHAT_ID } from '../../constants/apiUrls';
import logo from 'assets/Wlogo.png';
import '../../styles/styles.scss';



class ChatPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            chatMinimized: false
        };
        this.handleChatMinimized = this.handleChatMinimized.bind(this);
    }
    handleChatMinimized() {
        this.setState({ chatMinimized: true });
    }

    componentDidMount() {
        // Grab techId, name, email, and workOrderId from query strings
        const params = new URLSearchParams(window.location.search);
        const techId = params.get('techid') || '';
        const name = params.get('techName') || '';
        const email = params.get('techemail') || '';
        const workOrderId = params.get('workorder') || '';
        const workorderValue = (workOrderId !== undefined && workOrderId !== null && workOrderId !== '') ? workOrderId : 'N/A';
        // Log the parameters for debugging
        console.log('ChatPage params:', {
            techId,
            name,
            email,
            workOrderId,
            workorderValue
        });
        // Show spinner on mount
        this.setState({ loading: true }, () => {
            // Inline script injection 
            (function (n, u, port, chatId, techId, name, email, workorderValue, onMinimized) {
                window.CXoneDfo = n;
                window[n] = window[n] || function () { (window[n].q = window[n].q || []).push(arguments); };
                window[n].u = u;
                const e = document.createElement("script");
                e.type = "module";
                e.src = u + "?" + Math.round(Date.now() / 1e3 / 3600);
                e.onload = () => {
                    // After loader script loads, run all cxone commands
                    try {
                        window.cxone('init', port.toString());
                        window.cxone('chat', 'init', port, chatId);
                        window.cxone('chat', 'enableChatAlwaysOnline');
                        window.cxone('chat', 'setCustomCss', '[data-selector="ACTIVITY_BAR"]{display: none};');
                        window.cxone('chat', 'setFullDisplay');
                        window.cxone('chat', 'setCustomerName', name);
                        window.cxone('chat', 'setCaseCustomField', 'techid', techId);
                        window.cxone('chat', 'setCaseCustomField', 'techemail', email);
                        window.cxone('chat', 'setCaseCustomField', 'workorder', workorderValue);
                        window.cxone('chat', 'setCaseCustomField', 'functionalarea', ' ');
                        window.cxone('chat', 'setCaseCustomField', 'fstrequesttype', ' ');
                        window.cxone('chat', 'setCaseCustomField', 'fstadditionalinfo', ' ');
                        window.cxone('chat', 'openChatWindow');
                        if (window.cxone) {
                            window.cxone('chat', 'onChatWindowMinimized', onMinimized);
                        }
                    } catch (err) {
                        // Optionally handle errors
                    }
                    this.setState({ loading: false });
                };
                e.onerror = () => {
                    this.setState({ loading: false });
                };
                document.head.appendChild(e);
            }).call(this, 'cxone', NICE_CHAT_URL, NICE_CHAT_PORT, NICE_CHAT_ID, techId, name, email, workorderValue, this.handleChatMinimized);
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userData !== this.props.userData || prevProps.techData !== this.props.techData) {
            this.checkLoaded(this.props);
        }
    }

    checkLoaded(props) {
        let { userData } = props;
        if (userData) {
            this.setState({ loading: false });
        } else {
            this.setState({ loading: true });
        }
    }

    render() {
        const { loading, chatMinimized } = this.state;
        const regularSpinner = (
            <div className="chatpage-spinner">
                <div className="chatpage-spinner-circle" />
                <div className="chatpage-spinner-text">Chat loading...</div>
            </div>
        );
        if (chatMinimized) {
            return (
                <div className="chatpage-container">
                    <div className="chatpage-loaded-message">
                        <img id="wow-logo" src={logo} alt="WOW! Logo" className="chatpage-logo" />
                        <div className="chatpage-spinner-text" id="loaded">Chat Loaded!<br /><span style={{ fontSize: '.95em' }}>Click "We're online" to open chat.</span></div>
                    </div>
                </div>
            );
        }
        return (
            <div className="chatpage-container">
                <div className="chatpage-inner">
                    {loading && (
                        <div className="chatpage-spinner-overlay">
                            {regularSpinner}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default ChatPage;


// WEBPACK FOOTER //
// ./src/containers/pages/ChatPage.js